import { Button, Paper, Stack, Typography } from "@mui/material";
import { Home, Login, ReportProblemOutlined } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutePathNames } from "../helpers/Constants";
import { useAppSelector } from "../store/store";

export function NotFound() {
    const location = useLocation();
    const navigate = useNavigate();
    const loggedOnUserProfile = useAppSelector(state => state.loggedOnUserProfile.value);
    const primaryRoute = loggedOnUserProfile ? RoutePathNames.HOMEPAGE : RoutePathNames.LOGIN;

    return (
        <Paper className="Form" style={{ minHeight: "calc(100vh - 120px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
            <Stack direction="column" spacing={2} style={{ maxWidth: 620, width: "100%", alignItems: "center", textAlign: "center" }}>
                <ReportProblemOutlined color="secondary" style={{ fontSize: 72 }} />
                <Typography color="secondary" style={{ fontSize: 34, fontWeight: "bold" }}>
                    404
                </Typography>
                <Typography color="textPrimary" style={{ fontSize: 20, fontWeight: "bold" }}>
                    Page not found
                </Typography>
                <Typography color="textSecondary" style={{ fontSize: 14 }}>
                    The page <code>{location.pathname}</code> does not exist in RiskMan.
                </Typography>
                <Button
                    color="secondary"
                    onClick={() => navigate("/" + primaryRoute, { replace: true })}
                    size="medium"
                    variant="contained"
                >
                    {loggedOnUserProfile ? <Home /> : <Login />} &nbsp; {loggedOnUserProfile ? "Go to Home" : "Go to Login"}
                </Button>
            </Stack>
        </Paper>
    );
}
